export const SPOT_PRICE_AUTOFORM_SCHEMA_CODE = 'PSSPOTPRICEED';
